import axios from "axios";
import {
  GET_LEAD_FORM_REQUEST,
  GET_SURVEY_FORM_SUCCESS,
  GET_SURVEY_FORM_FAIL,
  GET_SURVEY_SECTIONS_REQUEST,
  GET_SURVEY_SECTIONS_SUCCESS,
  GET_SURVEY_SECTIONS_FAIL,
  SUBMIT_SURVEY_FORM_SUCCESS,
  SUBMIT_SURVEY_FORM_FAIL,
  SUBMIT_SURVEY_FORM_REQUEST,
  GET_SURVEY_RESULT_REQUEST,
  GET_SURVEY_RESULT_SUCCESS,
  GET_SURVEY_RESULT_FAIL,
  GET_SURVEY_REPORT_REQUEST,
  GET_SURVEY_REPORT_SUCCESS,
  GET_SURVEY_REPORT_FAIL,
  GET_DEFAULT_REPORT_REQUEST,
  GET_DEFAULT_REPORT_SUCCESS,
  GET_DEFAULT_REPORT_FAIL,
  GET_SURVEY_DETAIL_REQUEST,
  GET_SURVEY_DETAIL_SUCCESS,
  GET_SURVEY_DETAIL_FAIL,
} from "../constant";

export const getSurveyFormData = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_LEAD_FORM_REQUEST });
    let token = localStorage.getItem("customer_token");
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/getQues`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({ type: GET_SURVEY_FORM_SUCCESS, payload: res?.data?.data });
      })
      .catch((err) => {
        console.error("GET SURVEY FORM DATA FAIL", err);
        dispatch({ type: GET_SURVEY_FORM_FAIL });
      });
  };
};

export const getSurveySectionData = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_SURVEY_SECTIONS_REQUEST });
    let token = localStorage.getItem("customer_token");
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/getSections`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({
          type: GET_SURVEY_SECTIONS_SUCCESS,
          payload: res?.data?.data,
        });
      })
      .catch((err) => {
        console.error("GET SURVEY SECTION FAIL", err);
        dispatch({ type: GET_SURVEY_SECTIONS_FAIL });
      });
  };
};

export const submitResponseData = (data) => {
  return async (dispatch) => {
    let token = localStorage.getItem("customer_token");
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/submitRes`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
      })
      .catch((err) => {
        console.error("SUBMIT RESPONSE ERROR", err);
      });
  };
};

export const submitSurveyData = (data, navigate) => {
  return async (dispatch) => {
    let token = localStorage.getItem("customer_token");
    dispatch({ type: SUBMIT_SURVEY_FORM_REQUEST });
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/submitSurvey`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({ type: SUBMIT_SURVEY_FORM_SUCCESS });
        navigate(`/thank-you/${data.survey_id}/${data.ss_id}`);
      })
      .catch((err) => {
        console.error("SUBMIT RESPONSE ERROR", err);
        dispatch({ type: SUBMIT_SURVEY_FORM_FAIL });
      });
  };
};

export const getSurveyResult = (data) => {
  return async (dispatch) => {
    let token = localStorage.getItem("customer_token");
    dispatch({ type: GET_SURVEY_RESULT_REQUEST });
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/getResult`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({ type: GET_SURVEY_RESULT_SUCCESS, payload: res.data?.data });
      })
      .catch((err) => {
        console.error("SUBMIT RESPONSE ERROR", err);
        dispatch({ type: GET_SURVEY_RESULT_FAIL });
      });
  };
};

export const getSurveyResultPreview = (data) => {
  return async (dispatch) => {
    let token = localStorage.getItem("customer_token");
    dispatch({ type: GET_SURVEY_RESULT_REQUEST });
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/getResultPreview`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({ type: GET_SURVEY_RESULT_SUCCESS, payload: res.data?.data });
      })
      .catch((err) => {
        console.error("SUBMIT RESPONSE ERROR", err);
        dispatch({ type: GET_SURVEY_RESULT_FAIL });
      });
  };
};

export const getSurveyReport = (data) => {
  return async (dispatch) => {
    let token = localStorage.getItem("customer_token");
    dispatch({ type: GET_SURVEY_REPORT_REQUEST });
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/showReport`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({ type: GET_SURVEY_REPORT_SUCCESS, payload: res.data?.data });
      })
      .catch((err) => {
        dispatch({ type: GET_SURVEY_REPORT_FAIL });
      });
  };
};

export const getSurveyReportPreview = (data) => {
  return async (dispatch) => {
    let token = localStorage.getItem("customer_token");
    dispatch({ type: GET_SURVEY_REPORT_REQUEST });
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/showReportPreview`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({ type: GET_SURVEY_REPORT_SUCCESS, payload: res.data?.data });
      })
      .catch((err) => {
        dispatch({ type: GET_SURVEY_REPORT_FAIL });
      });
  };
};

export const getDefaultReport = (data) => {
  return async (dispatch) => {
    let token = localStorage.getItem("customer_token");
    dispatch({ type: GET_DEFAULT_REPORT_REQUEST });
    let options = {
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/survey/getDefaultReport?survey_id=${data}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await axios(options)
      .then((response) => {
        dispatch({
          type: GET_DEFAULT_REPORT_SUCCESS,
          payload: response.data?.data,
        });
      })
      .catch((err) => {
        dispatch({ type: GET_DEFAULT_REPORT_FAIL });
      });
  };
};

export const getSurveyDetail = (data) => {
  console.log("GET SURVEY DETAIL ACTION", data);
  return async (dispatch) => {
    dispatch({ type: GET_SURVEY_DETAIL_REQUEST });
    let token = localStorage.getItem("customer_token");
    let options = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/frnt/getSurveyDetail`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    await axios(options)
      .then((res) => {
        console.log(res);
        localStorage.setItem("customer_token", res?.data?.token);
        dispatch({ type: GET_SURVEY_DETAIL_SUCCESS, payload: res?.data?.data });
      })
      .catch((err) => {
        console.error("GET SURVEY DETAIL FAIL", err);
        dispatch({ type: GET_SURVEY_DETAIL_FAIL });
      });
  };
};
